import styled from 'styled-components';

const fixedHeaderHeight = '0px';

export const HeaderSection = styled.section`
  display: flex;
  flex-direction: row;
  margin-bottom: 1rem;
  justify-content: space-between;
`;

export const FullWidthContainer = styled.section`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;
  gap: 0px 0px;
  grid-auto-flow: row;
  grid-template-areas:
    "Header Header Header"
    "MainContent MainContent MainContent"
    "MainContent MainContent MainContent";
`;

export const FullWidthMainContent = styled.section`
  display: grid;
  grid-template-columns: minmax(350px, 0.3fr) 1fr;
  grid-template-rows: 1fr;
  gap: 0px 0px;
  grid-auto-flow: row;
  grid-template-areas:
    "Aside Main Main"
    "Aside Main Main"
    "Aside Main Main";
  grid-area: MainContent;
  
  @media (max-width: 1200px) {
    grid-template-columns: minmax(285px, 0.3fr) 1fr;
  }
  
  @media (max-width: 1024px) {
    display: flex;
    flex-direction: column;
  }
`;

export const FullWidthAside = styled.aside`
  position: relative;
  grid-area: Aside;
  background: ${props => props.theme.cards.primary};
  border: 1px solid ${props => props.theme.cards.border};
  border-radius: ${props => props.theme.radius.primary};
  margin: 2rem 0 4rem 2rem;
  z-index: 9;
  height: fit-content;
  
  @media (max-width: 1024px) {
    //border-bottom: 1px solid ${props => props.theme.header.border};
    margin: 2rem 1rem 0 1rem;
  }
  
  > header {
    display: flex;
    align-items: center;
    flex-direction: row;
    position: relative;
    //position: sticky;
    top: ${fixedHeaderHeight};
    padding: 0rem 2rem;
    height: 3.5rem;
    z-index: 99;
    border-bottom: 1px solid ${props => props.theme.cards.border};
    background: ${props => props.theme.cards.primary};
    border-radius: ${props => props.theme.radius.primary} ${props => props.theme.radius.primary} 0 0;

    > svg {
      margin-right: 1rem;
      color: ${props => props.theme.colors.muted};
    }

    > input {
      border: none;
      height: 100%;
      background: transparent;
      width: 100%;
      color: ${props => props.theme.colors.white};

      &::placeholder {
        color: ${props => props.theme.colors.muted};
      }
    }
  }
  
  > main {
    padding: 0 2rem 2rem 2rem;
    margin-top: 1rem;
    height: 100vh;
    height: auto;

    @media (max-width: 1024px) {
      height: auto;
      max-height: 335px;
      overflow-y: scroll;

      ::-webkit-scrollbar {
        width: 20px;
      }

      ::-webkit-scrollbar-thumb {
        border-radius: 8px;
        border: 8px solid rgba(0, 0, 0, 0);
        background-clip: padding-box;
        border-radius: 9999px;
        background-color: ${props => props.theme.colors.muted}50;
      }
    }
  }
`;

export const FullWidthMain = styled.main`
  grid-area: Main;

  > div {

    > div {

      > div {

      @media (max-width: 768px) {
        min-height: 370px !important;
      }

      @media (max-width: 425px) {
        min-height: 150px !important;
      }
    }
  }
}
`;

export const PlayerContainer = styled.div`
  position: relative;
  width: 100%;
  border-radius: 12px 12px 0 0;
  overflow: hidden;

  &.react-player > div {
    position: absolute !important; // Scaling will occur since parent is relative now
  }

  .react-player {
    position: relative;
    padding-bottom: 56.25%;
    padding-top: 0;
    height: 0;
    overflow: hidden;
    background: transparent;
    z-index: 9;

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
`;

export const ExerciseButtonContainer = styled.footer`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  border-radius: 0 0 24px 24px;
  padding: 1rem;
  margin-bottom: 2rem;
  color: ${props => props.theme.colors.white};
  background: ${props => props.theme.cards.tertiary};
  border: 1px solid ${props => props.theme.cards.border};
  animation: 2s infinite ease-in-out pulseAnimation2;
  transition: all 0.2s ease-in-out;
  font-weight: 600;
  cursor: pointer;
  

  @media (max-width: 425px) {
    font-size: 14px;
  }

  @media (max-width: 400px) {
    font-size: 12px;
  }

  &:hover {
    background: ${props => props.theme.colors.muted}60;
  }

  > p {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    text-transform: uppercase;
    letter-spacing: 2px;
    font-size: 12px;

    > img {
      height: 20px;
      width: 20px;
    }
  }
`

export const ModuleITitle = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1.5rem;
  margin-bottom: 1rem;
  border-bottom: 1px solid ${props => props.theme.cards.border};
  padding-bottom: 1rem;

  > aside {
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${props => props.theme.background.primary};
    height: 40px;
    width: 40px;
    border-radius: 50%;

    > svg {
    }

    > img {
      height: 64px;
      width: fit-content;
    }
  }

  > main {

    > h5 {
      font-size: 11px;
      font-weight: 500;
      color: ${props => props.theme.colors.muted};
      text-transform: uppercase;
      letter-spacing: 1px;
      margin-bottom: 2px;
    }

    > h2 {
      font-size: 16px;
      font-weight: 600;
      line-height: 1;
    }
  }
`;

export const ItemList = styled.div`
  width: 100%;
  display: flex;
  gap: 1.5rem;
  user-select: none;
  
  > ul {
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    
    > li {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      z-index: 0;

      > p, a {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 0.5rem;
        font-size: 13px;
        cursor: pointer;
        color: ${props => props.theme.colors.white};
        text-decoration: none;
        transition: padding 0.2s ease-in-out 0s,color 0.2s ease-in-out 0s;

        &.selected {
          font-weight: 900;
        }
        
        &:hover {
          padding-left: 4px;
        }
        
        &.selected {
          font-weight: 600;
        }

        > span {
          display: flex;
          flex-direction: row;
        }
      }
    }
  }
`;

export const RatingVideoContainer = styled.footer`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  

  > aside {
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 1rem;

    > span {
      font-size: 14px;
    }

    > p {
      display: flex;
      align-items: center;
      font-size: 12px;
      gap: 0.5rem;
      padding-left: 1rem;
      color: ${props => props.theme.colors.muted};
      border-left: 1.75px solid ${props => props.theme.colors.muted}70;

      > svg {
        font-size: 20px;
      }
    }
  }

  > main {
    @media (max-width: 580px) {
      display: none;
    }
  }
`;

export const Center = styled.div`
  width: 100%;
  padding: 4rem 25rem;
  position: relative;
  display: flex;
  align-items: flex-start;
  flex-direction: column;

  > div {
    > div {
      min-height: 500px;
    }
  }

  @media (max-width: 2300px) {
    padding: 4rem 22rem;

    > div {
      > div {
        min-height: 500px;
      }
    }
  }

  @media (max-width: 2100px) {
    padding: 2rem 18rem;
  }

  @media (max-width: 1900px) {
    padding: 2rem 10rem;
  }

  @media (max-width: 1600px) {
    padding: 2rem 12rem;
  }

  @media (max-width: 1500px) {
    padding: 2rem 8rem;
  }

  @media (max-width: 1440px) {
    padding: 2rem 2rem;
  }

  /* MOBILE */
  @media (max-width: 480px) {

  }
  
  > header {
    position: relative;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    width: 100%;
    margin-bottom: 2rem;
    
    > div {
      margin-bottom: 1.5rem;
      color: ${props => props.theme.colors.white};

      span, a, p {
        color: ${props => props.theme.colors.white} !important;
      }
    }
    
    > h1 {
      margin-bottom: 1rem;
      font-size: 40px;
      color: #ffffff;

      @media (max-width: 1024px) {
        color: ${props => props.theme.colors.white};
        font-size: 30px;
      }
      
      @media (max-width: 425px) {
        font-size: 24px;
      }
    }
    
    > p {
      font-size: 14px;
      color: #ffffff;

      @media (max-width: 1024px) {
        color: ${props => props.theme.colors.white};
      }
    }
  }
`;

export const CommentsContainer = styled.section`
position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;

  > div {

    > header{
      display: flex;

      > h3 {
        font-size: 18px;
        font-weight: 700;
      }
    }
  }
`;


export const Commentmain = styled.section`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 2rem;

  > aside {
    
    @media (max-width: 500px) {
      display: none;
    }
  }

  > main {
    width: 100%;
    margin-bottom: 2rem;
    position: relative;

    > div {
      width: 100%;
      border: 1px solid ${props => props.theme.cards.border}; 
      padding: 1rem; 
      border-top: 1px solid ${props => props.theme.colors.muted}50;
      border-left: 1px solid ${props => props.theme.colors.muted}50;
      border-right: 1px solid ${props => props.theme.colors.muted}50;
      border-bottom: 1px solid ${props => props.theme.colors.muted}50;
      border-top-left-radius: 0px;
      border-top-right-radius: 24px;
      border-bottom-left-radius: 24px;
      border-bottom-right-radius: 24px;
      background: ${props => props.theme.cards.primary};

      > textarea {
        width: 100%;
        min-height: 150px;
        border: none;
        padding: 0px;
        padding-bottom: 2rem;
        box-sizing: border-box;
        background: transparent;
        resize: none;
        color: ${props => props.theme.colors.white};

        &::placeholder {
          color: ${props => props.theme.colors.muted};
        }
      }

      > button {
        position: absolute;
        left: -5px;
        bottom: 5px;
        background: transparent;
        width: 100%;
        height: 2rem;
        margin-top: -2rem;
        border: none;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        color: ${props => props.theme.colors.white};
        text-align: right;
        padding: 0 12px;
        cursor: pointer;
        font-weight: 500;

        &:disabled {
          color: ${props => props.theme.colors.white}70;
          cursor: auto;
        }
      }
    }
  }
`;


export const MyCommentsContainer = styled.section`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 2rem;

  > header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    margin-bottom: 1rem;
  }

  > p {
    text-align: justify;
    font-size: 14px;
  }

  > hr {
    margin: 2rem 0;
  }
`;

export const TrashIcon = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
  background: #948cbf1c;
  border-radius: 50%;

  > svg {
    color: ${props => props.theme.colors.white};
  }
`;

export const MaterialsContainer = styled.section`
  position: relative;
  width: 100%;
  margin: 0 0 2rem 0;

  > h3 {
    font-size: 18px;
    font-weight: 700;
  }

  > main {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    margin: 2rem 0;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 1rem;
    align-items: start;

    @media (max-width: 1224px) {
      grid-template-columns: repeat(3, 1fr);
    }

    @media (max-width: 1025px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 425px) {
      display: flex;
      flex-direction: column;

      > div {
        width: 100%;

        > a {
          width: 100%;
        }
      }
    }
  }
`;

export const BreadcrumbsContainer = styled.div`
  margin-bottom: 3rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  color: ${props => props.theme.colors.white} !important;
  
  > button {
    display: flex;
    align-items: center;
    background: transparent;
    border: none;
    color: #ffffff;
    transition: all 0.2s ease-in-out;
    cursor: pointer;
    font-weight: 400;
    font-size: 14px;
    font-weight: 600;
    text-transform: uppercase;

    &:hover {
      text-decoration: underline;
      transform: translateX(0.25rem);
    }
  }
`;

export const SearchNotFound = styled.p`
  font-size: 12px;
`;